export const insuranceKnowledge = {
  formations: {
    "Brevet fédéral en assurance privée": {
      description: "Formation approfondie pour les professionnels de l'assurance privée",
      source: "https://www.vbv.ch/fr/",
      details: [
        "Durée: 2-3 ans",
        "Reconnu au niveau fédéral",
        "Spécialisation en assurance privée"
      ]
    },
    "Brevet fédéral en assurance sociale": {
      description: "Formation spécialisée dans le domaine des assurances sociales",
      source: "https://www.vbv.ch/fr/",
      details: [
        "Expertise en assurances sociales",
        "Reconnaissance fédérale",
        "Formation continue possible"
      ]
    }
  },
  regulations: {
    "LSA": {
      name: "Loi sur la surveillance des assurances",
      source: "https://www.svv.ch/fr/",
      key_points: [
        "Cadre légal pour les assureurs",
        "Protection des assurés",
        "Exigences de solvabilité"
      ]
    },
    "LCA": {
      name: "Loi sur le contrat d'assurance",
      source: "https://www.svv.ch/fr/",
      key_points: [
        "Droits et obligations des parties",
        "Conditions des contrats",
        "Procédures de résiliation"
      ]
    }
  },
  market_info: {
    companies: {
      "Allianz Suisse": {
        products: ["Assurance vie", "Assurance non-vie", "Prévoyance professionnelle"],
        specialties: ["Solutions entreprises", "Assurance véhicules"]
      },
      "AXA Suisse": {
        products: ["Assurance vie", "Assurance non-vie", "Prévoyance"],
        specialties: ["Assurance cyber", "Solutions digitales"]
      },
      "Generali Suisse": {
        products: ["Assurance vie", "Assurance non-vie"],
        specialties: ["Solutions patrimoniales", "Protection juridique"]
      },
      "Baloise": {
        products: ["Assurance vie", "Assurance non-vie", "Banking"],
        specialties: ["Solutions intégrées", "Services financiers"]
      },
      "Vaudoise": {
        products: ["Assurance vie", "Assurance non-vie"],
        specialties: ["Approche régionale", "Service personnalisé"]
      },
      "La Mobilière": {
        products: ["Assurance vie", "Assurance non-vie"],
        specialties: ["Modèle coopératif", "Ancrage local"]
      }
    },
    trends: [
      "Digitalisation des services",
      "Cyber-assurance",
      "Durabilité et ESG",
      "Personnalisation des offres"
    ]
  }
};